import { render } from "./TermsPage.vue?vue&type=template&id=606b993e&scoped=true&ts=true"
import script from "./TermsPage.vue?vue&type=script&lang=ts"
export * from "./TermsPage.vue?vue&type=script&lang=ts"

import "./TermsPage.vue?vue&type=style&index=0&id=606b993e&scoped=true&lang=css"

import exportComponent from "/Users/simon/Dev/Github/Jakowicz/MnemonicGames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606b993e"]])

export default __exports__